import icon from '../../assets/media/icons/arrow-right.svg';
import iconDark from '../../assets/media/icons/arrow-right-dark.png';
import { ThemeEnum } from '../../utils/enums';

import './arrowButton.scss';

const ArrowButton = ({ theme }: { theme: ThemeEnum }) => (
  <button type='button' className='arrow-button'>
    <img src={theme === ThemeEnum.Dark ? iconDark : icon} alt='arrow right' />
  </button>
);

export default ArrowButton;
